import React from "react";
import {
  showError,
  showSuccess,
} from "../../../../../../../../utils/showMessage.js";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CrossButton from "../../../../../../../common/ButtonSpinner/CrossButton.js";
import GeneralButton from "../../../../../../../common/SaveButton/GeneralButton.js";
import CustomModal from "../../../../../../../common/CustomModal/CustomModal.js";
import Images from "../../../../../../../../utils/images.js";
import "react-toastify/dist/ReactToastify.css";

import { truncateData } from "../../../../../../../../api/database_gui.js";

const TruncateDataPopup = ({
  visible,
  onClose,
  onSave,
  dbName,
  tableName,
  appId,
  systemUserId,
  setTruncateData,
  loading,
  setLoading,
  databaseInfo,
  resourceAccessID,
}) => {
  if (!visible) return null;

  const handleConfirm = async () => {
    try {
      const { data, error } = await truncateData(
        appId,
        systemUserId,
        dbName,
        tableName,
        resourceAccessID
      );
      if (error) {
        // Handle error response from backend
        let readableError = "Error truncating table. Please try again.";
        
        if (Array.isArray(error?.message)) {
          const backendMessage = error.message[0];
          
          // Check for foreign key constraint errors
          if (backendMessage.toLowerCase().includes("foreign key") || 
              backendMessage.toLowerCase().includes("referenced by") ||
              backendMessage.toLowerCase().includes("constraint") ||
              backendMessage.toLowerCase().includes("cannot truncate")) {
            readableError = `Cannot truncate table "${tableName}" because it has foreign key relationships. Please remove the foreign key constraints first or use CASCADE option if supported.`;
          } else {
            readableError = backendMessage;
          }
        } else if (typeof error === 'string') {
          readableError = error;
        }
        
        showError(readableError);
        return;
      }
      onSave();
      // Use backend success message if available, otherwise fallback to default
      const successMessage = data?.message || `Table "${tableName}" truncated successfully!`;
      showSuccess(successMessage);
      onClose();
    } catch (error) {
      showError(error.message || "Error truncating table. Please try again.");
    }
  };

  return (
    <CustomModal 
      open={visible} 
      handleClose={onClose}
      width="35%"
    >
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <div className="d-flex align-items-center mb-1">
              {databaseInfo === "MySQL" && (
                <img src={Images.mysql} alt="MySQL" width="24" height="24" className="me-2" />
              )}
              {databaseInfo === "PostgreSQL" && (
                <img src={Images.pssql} alt="PostgreSQL" width="24" height="24" className="me-2" />
              )}
              {databaseInfo === "MSSQL" && (
                <img src={Images.mssql} alt="MSSQL" width="24" height="24" className="me-2" />
              )}
              <h3 className="border-0 customize-column-name mb-0">
                Truncate Data
              </h3>
            </div>
            <p className="text-muted mb-0 fs-14px">
              Remove all data from a table while keeping the table structure intact.
            </p>
          </div>
          <CrossButton onClick={onClose} />
        </div>

        <div className="mb-4">
          <div className="alert alert-warning py-3">
            <div className="d-flex align-items-start">
              <img
                src={Images.InfoIcon}
                alt="warning"
                width="16"
                height="16"
                className="me-2 mt-1"
              />
              <div>
                <strong>Warning:</strong> Are you sure you want to truncate the table{" "}
                <code className="bg-light px-2 py-1 rounded">{tableName}</code> from database{" "}
                <code className="bg-light px-2 py-1 rounded">{dbName}</code>?
                <br />
                <small className="text-muted">
                  This action cannot be undone and will permanently delete all data in the table.
                </small>
              </div>
            </div>
          </div>
        </div>

        <Row className="pt-4 mb-3 justify-content-end">
          <Col sm="auto">
            <GeneralButton
              onClickEvent={onClose}
              className="me-1"
              value="Cancel"
              color="#505050"
              variant="outlined"
              size="large"
            />
          </Col>
          <Col sm="auto" className="me-sm-2 p-0">
            {loading ? (
              <GeneralButton
                onClickEvent={handleConfirm}
                variant="contained"
                disabled={true}
                className="me-1"
                value={
                  <img src={Images.Loader} width="26px" height="26px" />
                }
                size="large"
              />
            ) : (
              <GeneralButton
                onClickEvent={handleConfirm}
                className="me-1"
                value="Truncate"
                variant="contained"
                size="large"
              />
            )}
          </Col>
        </Row>
      </div>
    </CustomModal>
  );
};

export default TruncateDataPopup;
